<template>
<Teleport to="#modal-portal-target">
<div v-if="$store.getters['common/modalName'] === 'listreservations'">
    <div class="modal-header">
        <h3 class="modal-title">
            {{ product.name }} - {{ $_locale('reservation') }}
        </h3>
    </div>
    
    <template v-if="isVisible('reservationList')">
        <div class="modal-body reservation-modal">
            <golf-reservations-list 
                :reservation="activeReservation"
                @selected="toggleActive('editGolfReservation', true)" />
        </div>
        <div class="modal-footer">
            <button class="btn btn-default pull-left" @click="$store.commit('common/setModal', null)">
                {{ $_locale('close') }}
            </button>
        </div>
    </template>

    <template v-if="isVisible('editGolfReservation')">
        <edit-golf-reservation @cancel="toggleActive('reservationList', true)" />
    </template>
</div>
</Teleport>
</template>

<script>
import { mapGetters } from 'vuex'
import GolfReservationsList from './GolfReservationsList.vue'
import EditGolfReservation from './EditGolfReservation.vue'

export default {
    components: {
        GolfReservationsList,
        EditGolfReservation,
    },
    data: () => ({
        visible: 'reservationList'
    }),
    computed: {
        ...mapGetters({
            activeReservation: 'calendar/activeReservation',
            product: 'ecom/product',
            adminMode: 'common/adminMode',
        }),
    },
    methods: {
        isVisible(name) {
            return name === this.visible; 
        },
        toggleActive(name, value) {
            this.visible = value ? name : 'reservationList';
        },
    },
}
</script>